import { TextInput } from "../TextInput"
import { Icon } from "../Icon"
import { TableSearchInputProps } from "./types"

export const TableSearchInput = ({ label = "Search", ...rest }: TableSearchInputProps) => {
  // For now we won't pass in the ref because the ui library does not have access to Tailwind's theme object.
  // We need the theme object in order to use JS to determine which of these to render and therefore pass the ref to
  return (
    <>
      {/* On mobile: */}
      <div className="block w-full md:hidden">
        <TextInput
          aria-label={label}
          type="search"
          size="md"
          startAdornment={<Icon size="sm" className="flex-none" name="MagnifyingGlass" />}
          {...rest}
        />
      </div>
      {/* On tablet and larger */}
      <div className="hidden w-full max-w-[280px] md:block">
        <TextInput
          aria-label={label}
          type="search"
          size="sm"
          startAdornment={<Icon size="xs" className="flex-none" name="MagnifyingGlass" />}
          {...rest}
        />
      </div>
    </>
  )
}

TableSearchInput.displayName = "Table.SearchInput"
